import React, { FC } from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { DataTypeForES } from '@ariksa/reporting';
import { Flex, HStack, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { OutlinedMenuButton } from 'components/DataEntry/Button/OutlinedMenuButton';
import { ExportIcon, PieChartIcon } from 'components/Icons';
import { RegionAndVPCFilter } from 'containers/Inventory/CloudInventory/Components/Overview/RegionAndVPCFilter';
import { useInventoryContext } from 'containers/Inventory/CloudInventory/hooks/context';
import { ExportAlertsModal } from 'containers/SharedState/Components/ExportAlerts/ExportAlertsModal';

import { selectInventory } from '../selector';

const VPC_FILTER_RESOURCE_TYPES = new Set<string>([
  NativeResources.RelationalDatabaseService,
  NativeResources.RdsCluster,
  NativeResources.DocumentDb,
  NativeResources.DocumentDbCluster,
  NativeResources.Neptune,
  NativeResources.NeptuneCluster,
  NativeResources.ElastiCache,
  NativeResources.ElastiCacheReplicationGroup,
  NativeResources.ElasticSearch,
  NativeResources.RedshiftCluster,
  NativeResources.GcpCloudSql,
  NativeResources.GcpsqlInstances,
  NativeResources.GcpMemorystoreRedis,
  NativeResources.AzureSqlServer,
  NativeResources.AzureSqldbServersDatabase,
  NativeResources.AzurePostgreSqlFlexibleServer,
  NativeResources.AzurePostgresSqlFlexibleServersDatabase,
  NativeResources.AzureMysqlFlexibleServer,
  NativeResources.AzureMysqlFlexibleServerDatabase,
  NativeResources.AzureRedis,
  NativeResources.AzureCosmosCassandraCluster,
  'GCPAlloyDB',
]);

// Removed the onOpenAddWhitelist prop: its only trigger was a commented-out button.
export const HeaderTable: FC = () => {
  const { instanceResourceType, currentCategory } = useSelector(
    selectInventory,
  );
  const { setShowInventorySummary } = useInventoryContext();
  const exportAlerts = useDisclosure();
  const showVpcFilter = VPC_FILTER_RESOURCE_TYPES.has(instanceResourceType);

  return currentCategory === 'Overview' || !!instanceResourceType ? (
    <BorderedBox>
      <HStack spacing={2} justify="space-between">
        {!!instanceResourceType && (
          <HStack w="full">
            <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
            <RegionAndVPCFilter showVpc={showVpcFilter} />
          </HStack>
        )}
        {currentCategory === 'Overview' && (
          <Flex w="full" justify="flex-end">
            <OutlinedMenuButton
              menuItems={[
                {
                  label: 'Show Summary',
                  icon: <PieChartIcon />,
                  onClick: () => setShowInventorySummary(true),
                },
                {
                  label: 'Export to SIEM',
                  icon: <ExportIcon />,
                  onClick: () => exportAlerts.onOpen(),
                },
              ]}
            >
              Actions
            </OutlinedMenuButton>
          </Flex>
        )}
        {/*<ExportAlerts
          type={DataTypeForES.Resources}
          tooltip="Export inventory"
        />
        <PrimaryIconButton
          aria-label="summary"
          tooltip="Show Cloud Summary"
          onClick={() => setShowInventorySummary(true)}
        >
          <PieChartIcon />
        </PrimaryIconButton>*/}
        {/*<PrimaryIconButton
            aria-label="download"
            tooltip="Download inventory report"
          >
            <DownloadIcon />
          </PrimaryIconButton>
          <PrimaryIconButton
            aria-label="share"
            tooltip="Share with another user"
          >
            <ShareIcon />
          </PrimaryIconButton>
          <PrimaryIconButton
            aria-label="calender"
            tooltip="Show inventory on specific date"
          >
            <CalenderIcon />
          </PrimaryIconButton>*/}
      </HStack>
      {exportAlerts.isOpen && (
        <ExportAlertsModal
          isOpen={exportAlerts.isOpen}
          onClose={exportAlerts.onClose}
          type={DataTypeForES.Resources}
        />
      )}
    </BorderedBox>
  ) : (
    <></>
  );
};
